import { foreignKey, pgEnum, pgTable, text, unique, uuid, uniqueIndex } from "drizzle-orm/pg-core";
import { id, temporalTimestamps, sortIndex } from "../../utils/sql";
import { shoppingListFoodItem } from "../../nutrition/shopping-list/shopping-list.sql";
import { relations, sql } from "drizzle-orm";
import { listCollection } from "../list-collection/list-collection.sql";

export const listType = pgEnum("list_type", ["shopping", "meal_prep"]);

// TODO: Separate "status" on this table?
export const list = pgTable("list", {
  ...id,
  ...temporalTimestamps,
  type: listType("type").notNull(),
  title: text("title").notNull(),
  collectionId: uuid("collection_id")
    .references(() => listCollection.id)
    .notNull(),
  // icon: text('icon'), // Url? Also maybe not MVP? "icon" could just be an emoji?
  // TODO: Sharing status - is this visibility? Or some more advanced permissions thing?
});

export const listRelations = relations(list, ({ one, many }) => ({
  collection: one(listCollection, {
    fields: [list.collectionId],
    references: [listCollection.id],
  }),
  sections: many(listSection),
  items: many(listItem),
}));

export const listSection = pgTable(
  "list_section",
  {
    ...id,
    ...sortIndex,
    ...temporalTimestamps,
    listId: uuid("list_id")
      .references(() => list.id)
      .notNull(),
    title: text("title").notNull(),
  },
  (t) => [
    unique("list_section_unique").on(t.listId, t.id),
    uniqueIndex("list_section_unique_sort_index").on(t.listId, t.sortIndex),
  ],
);

export const listSectionRelations = relations(listSection, ({ one, many }) => ({
  list: one(list, {
    fields: [listSection.listId],
    references: [list.id],
  }),
  items: many(listItem),
}));

export const listItemStatus = pgEnum("list_item_status", [
  "pending",
  "in_progress",
  "complete",
  "canceled",
]);

// TODO: Target time, due time?
// TODO: Keep quantity here or not?
export const listItem = pgTable(
  "list_item",
  {
    ...id,
    ...sortIndex,
    ...temporalTimestamps,
    listId: uuid("list_id")
      .references(() => list.id)
      .notNull(),
    sectionId: uuid("section_id"),
    label: text("label"),
    note: text("note"),
    status: listItemStatus("status").notNull(),
    // currentQuantity: doublePrecision("current_quantity"),
  },
  (t) => [
    unique("list_item_unique").on(t.listId, t.id),
    foreignKey({
      name: "list_item_section_fk",
      columns: [t.listId, t.sectionId],
      foreignColumns: [listSection.listId, listSection.id],
    }),
    uniqueIndex("list_item_unique_sort_index_in_section")
      .on(t.listId, t.sectionId, t.sortIndex)
      .where(sql`${t.sectionId} is not null`),
    uniqueIndex("list_item_unique_sort_index_no_section")
      .on(t.listId, t.sortIndex)
      .where(sql`${t.sectionId} is null`),
  ],
);

export const listItemRelations = relations(listItem, ({ one }) => ({
  list: one(list, {
    fields: [listItem.listId],
    references: [list.id],
  }),
  section: one(listSection, {
    fields: [listItem.sectionId],
    references: [listSection.id],
  }),

  // Unclear if this should be specific to shopping lists, or changed to a foodListItem and re-used across shopping + meal prep
  // Only include sub-type relationships if needed to fill in the base list_item fields
  shoppingListFoodItem: one(shoppingListFoodItem),
}));
